import { render, staticRenderFns } from "./AppModalOK.vue?vue&type=template&id=35650940&"
import script from "./AppModalOK.vue?vue&type=script&lang=js&"
export * from "./AppModalOK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports